module.exports = __webpack_public_path__ + "static/media/logo_baovietbank.456e0beb.svg";